import { SimpleUser, User } from "../../models/user"
import unescape from "lodash-es/unescape"
import { GlobalUser } from "../../models/globalUser"

const decodeNumericHtmlEntities = (str: string): string =>
    str.replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))

export function processUser<T extends User | SimpleUser | GlobalUser>(userDto: T): T {
    const translateLocale = (userDto as User).TranslateLocale

    return {
        ...userDto,
        FirstName: unescape(userDto.FirstName),
        LastName: unescape(userDto.LastName),
        ...(translateLocale !== undefined && {
            TranslateLocale: unescape(decodeNumericHtmlEntities(translateLocale))
        })
    }
}
